import { Step } from 'react-joyride';

export const dashboardSteps: Step[] = [
  {
    target: '#dashboard-welcome',
    content: 'Welcome to your Quixocial dashboard! This is your command center.',
    placement: 'center',
  },
  {
    target: '#create-post-button',
    content: 'You can create a new post by clicking here.',
    placement: 'bottom',
  },
  {
    target: '#recent-posts-widget',
    content: 'Your recent activities will be displayed here.',
    placement: 'right',
  },
  {
      target: '#scheduled-posts-widget',
      content: 'You can access some quick actions here.',
      placement: 'left',
  },
  {
      target: '#social-media-metrics-widget',
      content: 'Here you can see your social media metrics.',
      placement: 'bottom',
  }
];

export const onboardingSteps: Step[] = [
  {
    target: 'body',
    content: `
      <div style="text-align: center; padding: 20px;">
        <div style="font-size: 24px; font-weight: bold; margin-bottom: 12px; background: linear-gradient(135deg, #6366f1, #8b5cf6, #ec4899); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">
          🎉 Welcome to Quixocial!
        </div>
        <p style="font-size: 16px; color: #64748b; margin-bottom: 16px; line-height: 1.5;">
          Your all-in-one social media management platform. Let's get you set up for success!
        </p>
      </div>
    `,
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: 'main',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          📊 Your Command Center
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          The Dashboard gives you a complete overview of your social media performance, recent activities, and quick actions.
        </p>
        <div style="background: #f1f5f9; padding: 12px; border-radius: 8px; border-left: 4px solid #6366f1;">
          <strong style="color: #6366f1;">💡 Pro Tip:</strong> 
          <span style="color: #475569; font-size: 13px;">Check here daily to stay on top of your social media game!</span>
        </div>
      </div>
    `,
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: 'aside nav ul',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          🧭 Your Navigation Hub
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          The sidebar contains all your essential tools. Let's explore what each section can do for you.
        </p>
      </div>
    `,
    placement: 'right',
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: 'a[href="/app/clients"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          🎨 My Brands
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Your brand is automatically created when you sign up! Here you can set up your Brand Kit with brand voice, colors, target audience, and industry details to ensure consistent branding across all your content.
        </p>
        <div style="background: #e0f2fe; padding: 12px; border-radius: 8px; border-left: 4px solid #0ea5e9;">
          <strong style="color: #0369a1;">🎯 Brand Consistency:</strong> 
          <span style="color: #0c4a6e; font-size: 13px;">Add your brand kit to generate on-brand content automatically!</span>
        </div>
      </div>
    `,
    placement: 'right',
    offset: 10,
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: 'a[href="/app/team"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          👥 Team Management
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Collaborate with your team by inviting members, assigning roles, and managing permissions for seamless workflow.
        </p>
        <div style="background: #e0f2fe; padding: 12px; border-radius: 8px; border-left: 4px solid #0ea5e9;">
          <strong style="color: #0369a1;">🤝 Collaboration:</strong> 
          <span style="color: #0c4a6e; font-size: 13px;">Invite team members and manage access levels</span>
        </div>
      </div>
    `,
    placement: 'right',
    offset: 10,
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: 'a[href="/app/content-creation"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          ✨ Content Creation
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Generate high-quality AI-powered images and AR content with flexible options and full brand customization.
        </p>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-top: 12px;">
          <div style="text-align: center; padding: 8px;">
            <div style="font-size: 20px; margin-bottom: 4px;">🎨</div>
            <div style="font-size: 11px; color: #6366f1; font-weight: bold;">Ad Studio</div>
          </div>
          <div style="text-align: center; padding: 8px;">
            <div style="font-size: 20px; margin-bottom: 4px;">🥽</div>
            <div style="font-size: 11px; color: #8b5cf6; font-weight: bold;">AR Content</div>
          </div>
        </div>
      </div>
    `,
    placement: 'right',
    offset: 10,
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: 'a[href="/app/media"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          📁 Media Library
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Your central hub for storing, organizing, and reusing all uploaded and AI-generated media files.
        </p>
        <div style="background: #e0f2fe; padding: 12px; border-radius: 8px; border-left: 4px solid #0ea5e9;">
          <strong style="color: #0369a1;">📚 Organization:</strong> 
          <span style="color: #0c4a6e; font-size: 13px;">Keep all your assets organized and easily accessible</span>
        </div>
      </div>
    `,
    placement: 'right',
    offset: 10,
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: 'a[href="/app/posts"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          📝 Post Management
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Plan, design, and schedule social media posts—keeping your campaigns consistent and on track.
        </p>
        <div style="display: flex; gap: 8px; margin-top: 12px;">
          <div style="background: #fce7f3; padding: 8px 12px; border-radius: 20px; font-size: 12px; color: #be185d;">
            📅 Schedule
          </div>
          <div style="background: #e0f2fe; padding: 8px 12px; border-radius: 20px; font-size: 12px; color: #0369a1;">
            ✏️ Design
          </div>
        </div>
      </div>
    `,
    placement: 'right',
    offset: 10,
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: 'a[href="/app/one-click-creator"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          ⚡ One-Click Creator
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Instantly convert any image into branded posts for multiple platforms at once, making multi-channel publishing effortless.
        </p>
        <div style="background: #dcfce7; padding: 12px; border-radius: 8px; border-left: 4px solid #22c55e;">
          <strong style="color: #16a34a;">🚀 Efficiency:</strong> 
          <span style="color: #15803d; font-size: 13px;">One image → Multiple platform-ready posts</span>
        </div>
      </div>
    `,
    placement: 'right',
    offset: 10,
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: 'a[href="/app/schedule"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          📅 Content Calendar
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Visualize, organize, and manage all scheduled posts in a clean, calendar-based view.
        </p>
        <div style="background: #f3e8ff; padding: 12px; border-radius: 8px; border-left: 4px solid #7c3aed;">
          <strong style="color: #6d28d9;">📊 Planning:</strong> 
          <span style="color: #5b21b6; font-size: 13px;">See your entire content strategy at a glance</span>
        </div>
      </div>
    `,
    placement: 'right',
    offset: 10,
    disableBeacon: true,
  },
  {
    target: '#recent-posts-widget',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          📈 Recent Activity
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Stay updated with your latest posts, media uploads, and platform activities in real-time.
        </p>
      </div>
    `,
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '#scheduled-posts-widget',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          ⚡ Quick Actions
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Access your most common tasks instantly - invite team members, upload media, add clients, and create AI campaigns.
        </p>
      </div>
    `,
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: 'body',
    content: `
      <div style="text-align: center; padding: 20px;">
        <div style="font-size: 22px; font-weight: bold; margin-bottom: 16px; color: #1e293b;">
          🎯 Next Steps
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 16px; line-height: 1.5;">
          To get the most out of Quixocial, complete these essential setup tasks:
        </p>
        <div style="background: linear-gradient(135deg, #f0f9ff, #e0f2fe); padding: 16px; border-radius: 12px; border: 1px solid #0ea5e9; text-align: left;">
          <div style="font-size: 16px; font-weight: bold; color: #0369a1; margin-bottom: 12px;">
            🚀 Ready to Create:
          </div>
          <div style="font-size: 13px; color: #0c4a6e; line-height: 1.6;">
            <div style="margin-bottom: 8px;">🎨 <strong>Start Creating Content</strong> - Your brand is ready to go!</div>
            <div>✨ <strong>Set Up Brand Kit</strong> - Add brand voice, colors & style (optional)</div>
          </div>
        </div>
      </div>
    `,
    placement: 'center',
    disableBeacon: true,
  },
];

export const postsSteps: Step[] = [
    {
        target: '#posts-list',
        content: 'Here is the list of your posts.',
        placement: 'bottom',
    },
    {
        target: '#create-post-button',
        content: 'You can create a new post by clicking here.',
        placement: 'bottom',
    }
];


export const adStudioSteps: Step[] = [
  {
    target: 'body',
    content: `
      <div style="text-align: center; padding: 20px;">
        <div style="font-size: 24px; font-weight: bold; margin-bottom: 12px; background: linear-gradient(135deg, #6366f1, #8b5cf6, #ec4899); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">
          🎨 Welcome to Ad Studio
        </div>
        <p style="font-size: 16px; color: #64748b; margin-bottom: 16px; line-height: 1.5;">
          Your professional creative suite for generating stunning visuals
        </p>
      </div>
    `,
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '#product-image-upload',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          📸 Step 1: Product Images
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Upload one or multiple product images. Multiple images will automatically enable multi-product mode for showcasing collections.
        </p>
        <div style="background: #f1f5f9; padding: 12px; border-radius: 8px; border-left: 4px solid #6366f1;">
          <strong style="color: #6366f1;">💡 Pro Tip:</strong> 
          <span style="color: #475569; font-size: 13px;">Upload high-quality images (1024x1024 or higher) for best results</span>
        </div>
      </div>
    `,
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '#reference-images-section',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          🖼️ Step 2: Reference Images (Optional)
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Upload reference images to guide the visual style and composition of your generation. Perfect for matching existing brand aesthetics.
        </p>
        <div style="background: #e0f2fe; padding: 12px; border-radius: 8px; border-left: 4px solid #0ea5e9;">
          <strong style="color: #0369a1;">🎯 Smart Feature:</strong> 
          <span style="color: #0c4a6e; font-size: 13px;">AI will analyze and apply the style from your reference images</span>
        </div>
      </div>
    `,
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '#creative-style-controls',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          🎨 Step 3: Creative Style
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Define your visual\'s purpose, composition, and visual style. Choose from professional templates optimized for different platforms and audiences.
        </p>
        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 6px; margin-top: 12px;">
          <div style="background: #ede9fe; padding: 6px; border-radius: 6px; text-align: center;">
            <div style="font-size: 11px; font-weight: bold; color: #7c3aed;">Creative purpose</div>
          </div>
          <div style="background: #fce7f3; padding: 6px; border-radius: 6px; text-align: center;">
            <div style="font-size: 11px; font-weight: bold; color: #ec4899;">Style</div>
          </div>
          <div style="background: #ecfdf5; padding: 6px; border-radius: 6px; text-align: center;">
            <div style="font-size: 11px; font-weight: bold; color: #059669;">Composition</div>
          </div>
        </div>
      </div>
    `,
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '#multi-product-toggle',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          🔄 Step 4: Multi-Product Mode
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          When enabled, showcase multiple products in a single visual. Perfect for product collections, comparisons, or bundles.
        </p>
        <div style="background: #fef3c7; padding: 12px; border-radius: 8px; border-left: 4px solid #f59e0b;">
          <strong style="color: #d97706;">⚡ Feature:</strong> 
          <span style="color: #92400e; font-size: 13px;">Automatically enabled when you upload 2+ product images</span>
        </div>
      </div>
    `,
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '#brandify-toggle',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          🏷️ Step 5: Brandify Integration
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Automatically apply your brand colors, fonts, and style guidelines to ensure consistent brand identity across all visuals.
        </p>
        <div style="background: #dcfce7; padding: 12px; border-radius: 8px; border-left: 4px solid #22c55e;">
          <strong style="color: #16a34a;">🎯 Smart Feature:</strong> 
          <span style="color: #15803d; font-size: 13px;">Uses your Brand Kit settings for automatic brand alignment</span>
        </div>
      </div>
    `,
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '#advanced-options-section',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          ⚙️ Step 6: Advanced Options
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Fine-tune your visuals with professional controls:
        </p>
        <ul style="font-size: 13px; color: #475569; margin: 12px 0; padding-left: 16px; line-height: 1.4;">
          <li>• Custom text prompt</li>
          <li>• Text overlays with custom positioning</li>
          <li>• Psychological influence tuning</li>
        </ul>
        <div style="display: flex; gap: 8px; margin-top: 12px;">
          <div style="background: #fef9c3; padding: 8px 12px; border-radius: 20px; font-size: 12px; color: #ca8a04;">
            🎨 Text prompt
          </div>
          <div style="background: #e0f2fe; padding: 8px 12px; border-radius: 20px; font-size: 12px; color: #0369a1;">
            📝 Text & Overlay
          </div>
          <div style="background: #f3e8ff; padding: 8px 12px; border-radius: 20px; font-size: 12px; color: #7c3aed;">
            🧠 Psychology
          </div>
        </div>
      </div>
    `,
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '#creative-canvas',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          🖼️ Step 7: Preview Window
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Your generated visuals will appear here. You can preview, download, and create posts directly from the results. Use the form on the left to configure your settings and generate visuals.
        </p>
        <div style="background: #f1f5f9; padding: 12px; border-radius: 8px; border-left: 4px solid #6366f1;">
          <strong style="color: #6366f1;">💡 Pro Tip:</strong> 
          <span style="color: #475569; font-size: 13px;">Scroll down in the left panel to access Advanced Options, Brandify, and other powerful features!</span>
        </div>
      </div>
    `,
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: 'body',
    content: `
      <div style="text-align: center; padding: 20px;">
        <div style="font-size: 22px; font-weight: bold; margin-bottom: 16px; color: #1e293b;">
          🎉 You're Ready to Create!
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 16px; line-height: 1.5;">
          You now understand the complete Ad Studio workflow. Follow these steps to create professional content that convert!
        </p>
        <div style="background: linear-gradient(135deg, #f0f9ff, #e0f2fe); padding: 16px; border-radius: 12px; border: 1px solid #0ea5e9;">
          <div style="font-size: 16px; font-weight: bold; color: #0369a1; margin-bottom: 8px;">
            🚀 Quick Start Tips:
          </div>
          <div style="font-size: 13px; color: #0c4a6e; text-align: left;">
            • Upload high-quality product images<br>
            • Use reference images for style consistency<br>
            • Enable Brandify for automatic brand alignment<br>
            • Experiment with advanced options and psychology tuning
          </div>
        </div>
      </div>
    `,
    placement: 'center',
    disableBeacon: true,
  },

  {
    target: 'body',
    content: `
      <div style="text-align: center; padding: 20px;">
        <div style="font-size: 22px; font-weight: bold; margin-bottom: 16px; color: #1e293b;">
          🎉 You\'re Ready to Create!
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 16px; line-height: 1.5;">
          You now understand the complete Ad Studio workflow. Follow these 8 steps to create professional content that convert!
        </p>
        <div style="background: linear-gradient(135deg, #f0f9ff, #e0f2fe); padding: 16px; border-radius: 12px; border: 1px solid #0ea5e9;">
          <div style="font-size: 16px; font-weight: bold; color: #0369a1; margin-bottom: 8px;">
            🚀 Quick Start Tips:
          </div>
          <div style="font-size: 13px; color: #0c4a6e; text-align: left;">
            • Upload high-quality product images<br>
            • Use reference images for style consistency<br>
            • Enable Brandify for automatic brand alignment<br>
            • Experiment with different creative styles
          </div>
        </div>
      </div>
    `,
    placement: 'center',
    disableBeacon: true,
  },
];
export const postFormSteps: Step[] = [
  {
    target: 'body',
    content: 'Welcome to the post creation form! Let\'s create a new post together.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '#post-title',
    content: 'Start by giving your post a title.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#media-upload',
    content: 'Next, upload your media files. You can select multiple files to create a carousel post.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#platform-selection',
    content: 'Choose the social media platforms where you want to publish your post. Some platforms will be enabled automatically by analyzing the uploaded image. A new section will show up below with content type based on the uploaded image.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#content-editor',
    content: 'Write your post content here. You can use the AI assistant to generate captions and hashtags.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '#hashtags',
    content: 'Generate relevant hashtags for your post to increase its reach.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '#scheduling',
    content: 'You can schedule your post to be published at a later time.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '#publish-button',
    content: 'Once you\'re ready, you can publish your post or save it as a draft.',
    placement: 'top',
    disableBeacon: true,
  },
];

export const adStudio3DSteps: Step[] = [
  {
    target: 'body',
    content: `
      <div style="text-align: center; padding: 20px;">
        <div style="font-size: 24px; font-weight: bold; margin-bottom: 12px; background: linear-gradient(135deg, #3b82f6, #8b5cf6, #ec4899); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">
          🎯 Welcome to Ad Studio-3D
        </div>
        <p style="font-size: 16px; color: #64748b; margin-bottom: 16px; line-height: 1.5;">
          Transform your product images into stunning 3D models and AR experiences
        </p>
      </div>
    `,
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="image-upload-section"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          📸 Step 1: Upload Product Image
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Start by uploading a clear, high-quality image of your product. This will be transformed into a 3D model.
        </p>
        <div style="background: #f1f5f9; padding: 12px; border-radius: 8px; border-left: 4px solid #3b82f6;">
          <strong style="color: #3b82f6;">💡 Pro Tip:</strong> 
          <span style="color: #475569; font-size: 13px;">Use images with clean backgrounds and good lighting for best results</span>
        </div>
      </div>
    `,
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="advanced-options"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          ⚙️ Step 2: Advanced Options (Optional)
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Fine-tune your 3D model generation with advanced settings like PBR materials, polygon count, and texture quality.
        </p>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-top: 12px;">
          <div style="background: #ede9fe; padding: 6px; border-radius: 6px; text-align: center;">
            <div style="font-size: 11px; font-weight: bold; color: #7c3aed;">PBR Materials</div>
          </div>
          <div style="background: #fce7f3; padding: 6px; border-radius: 6px; text-align: center;">
            <div style="font-size: 11px; font-weight: bold; color: #ec4899;">Texture Quality</div>
          </div>
        </div>
      </div>
    `,
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="generate-3d-button"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          🚀 Step 3: Generate 3D Model
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Click here to start the 3D model generation. The process typically takes 2-5 minutes depending on complexity.
        </p>
        <div style="background: #dcfce7; padding: 12px; border-radius: 8px; border-left: 4px solid #22c55e;">
          <strong style="color: #16a34a;">⏱️ Processing Time:</strong> 
          <span style="color: #15803d; font-size: 13px;">AI analyzes → Creates geometry → Applies textures</span>
        </div>
      </div>
    `,
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '[data-tour="3d-preview-canvas"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          🖼️ Step 4: 3D Model Preview
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Your generated 3D model will appear here. You can rotate, zoom, and inspect it from all angles using mouse controls.
        </p>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-top: 12px;">
          <div style="text-align: center; padding: 8px;">
            <div style="font-size: 20px; margin-bottom: 4px;">🖱️</div>
            <div style="font-size: 11px; color: #3b82f6; font-weight: bold;">Interactive Controls</div>
          </div>
          <div style="text-align: center; padding: 8px;">
            <div style="font-size: 20px; margin-bottom: 4px;">📱</div>
            <div style="font-size: 11px; color: #8b5cf6; font-weight: bold;">AR Ready</div>
          </div>
        </div>
      </div>
    `,
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="action-buttons"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          🎬 Step 5: Next Actions
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Once your 3D model is ready, you can download it or create AR content directly from here.
        </p>
        <div style="display: flex; gap: 8px; margin-top: 12px;">
          <div style="background: #e0f2fe; padding: 8px 12px; border-radius: 20px; font-size: 12px; color: #0369a1;">
            ⬇️ Download GLB
          </div>
          <div style="background: #fef3c7; padding: 8px 12px; border-radius: 20px; font-size: 12px; color: #d97706;">
            📱 Create AR Ad
          </div>
        </div>
      </div>
    `,
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: 'body',
    content: `
      <div style="text-align: center; padding: 20px;">
        <div style="font-size: 22px; font-weight: bold; margin-bottom: 16px; color: #1e293b;">
          🎉 You're Ready to Create 3D Magic!
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 16px; line-height: 1.5;">
          You now understand the complete 3D Studio workflow. Upload an image and watch AI transform it into a professional 3D model!
        </p>
        <div style="background: linear-gradient(135deg, #f0f9ff, #e0f2fe); padding: 16px; border-radius: 12px; border: 1px solid #3b82f6;">
          <div style="font-size: 16px; font-weight: bold; color: #1e40af; margin-bottom: 8px;">
            🚀 Quick Start Tips:
          </div>
          <div style="font-size: 13px; color: #1e3a8a; text-align: left;">
            • Use high-resolution product images<br>
            • Enable PBR for realistic materials<br>
            • Adjust polygon count for your needs<br>
            • Create AR ads directly from your 3D models
          </div>
        </div>
      </div>
    `,
    placement: 'center',
    disableBeacon: true,
  },
];

export const adStudioARSteps: Step[] = [
  {
    target: 'body',
    content: `
      <div style="text-align: center; padding: 20px;">
        <div style="font-size: 24px; font-weight: bold; margin-bottom: 12px; background: linear-gradient(135deg, #10b981, #06b6d4, #3b82f6); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">
          📱 Welcome to Ad Studio-AR
        </div>
        <p style="font-size: 16px; color: #64748b; margin-bottom: 16px; line-height: 1.5;">
          Create immersive AR content from your 3D models
        </p>
      </div>
    `,
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="3d-model-selector"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          📦 Step 1: Select 3D Model
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Choose a 3D model from your media library. Models created in Ad Studio-3D will automatically appear here.
        </p>
        <div style="background: #f1f5f9; padding: 12px; border-radius: 8px; border-left: 4px solid #10b981;">
          <strong style="color: #10b981;">💡 Pro Tip:</strong> 
          <span style="color: #475569; font-size: 13px;">Models from 3D Studio come with their original images pre-linked</span>
        </div>
      </div>
    `,
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="source-image-selector"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          🖼️ Step 2: Source Image (If Needed)
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          If your 3D model doesn't have a linked source image, select one here. This image helps AI understand the product context.
        </p>
        <div style="background: #fef3c7; padding: 12px; border-radius: 8px; border-left: 4px solid #f59e0b;">
          <strong style="color: #d97706;">⚡ Auto-Detection:</strong> 
          <span style="color: #92400e; font-size: 13px;">Models from 3D Studio skip this step automatically</span>
        </div>
      </div>
    `,
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="generate-ar-button"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          🚀 Step 3: Generate AR content
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Click here to create your AR visual. AI will generate a realistic scene showing your product in augmented reality.
        </p>
        <div style="background: #dcfce7; padding: 12px; border-radius: 8px; border-left: 4px solid #22c55e;">
          <strong style="color: #16a34a;">🎯 Smart Feature:</strong> 
          <span style="color: #15803d; font-size: 13px;">Creates AR viewer URL and showcase in one process</span>
        </div>
      </div>
    `,
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '[data-tour="ar-preview-canvas"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          📱 Step 4: AR content Preview
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Your AR content will appear here, showing a realistic scene with a smartphone displaying your product in AR.
        </p>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-top: 12px;">
          <div style="text-align: center; padding: 8px;">
            <div style="font-size: 20px; margin-bottom: 4px;">📱</div>
            <div style="font-size: 11px; color: #10b981; font-weight: bold;">AR Experience</div>
          </div>
          <div style="text-align: center; padding: 8px;">
            <div style="font-size: 20px; margin-bottom: 4px;">📊</div>
            <div style="font-size: 11px; color: #06b6d4; font-weight: bold;">QR Code Access</div>
          </div>
        </div>
      </div>
    `,
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: 'body',
    content: `
      <div style="text-align: center; padding: 20px;">
        <div style="font-size: 22px; font-weight: bold; margin-bottom: 16px; color: #1e293b;">
          🎉 You're Ready to Create AR Magic!
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 16px; line-height: 1.5;">
          You now understand the complete AR Studio workflow. Transform your 3D models into engaging AR showcases!
        </p>
        <div style="background: linear-gradient(135deg, #ecfdf5, #d1fae5); padding: 16px; border-radius: 12px; border: 1px solid #10b981;">
          <div style="font-size: 16px; font-weight: bold; color: #047857; margin-bottom: 8px;">
            🚀 Quick Start Tips:
          </div>
          <div style="font-size: 13px; color: #065f46; text-align: left;">
            • Use 3D models from Ad Studio-3D for best results<br>
            • AR visuals work great for product demonstrations<br>
            • Share QR codes for mobile AR experiences<br>
            • Download visuals for social media campaigns
          </div>
        </div>
      </div>
    `,
    placement: 'center',
    disableBeacon: true,
  },
];

export
 const oneClickCreatorSteps: Step[] = [
  {
    target: 'body',
    content: `
      <div style="text-align: center; padding: 20px;">
        <div style="font-size: 24px; font-weight: bold; margin-bottom: 12px; background: linear-gradient(135deg, #6366f1, #8b5cf6, #ec4899); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">
          ⚡ Welcome to One-Click Creator
        </div>
        <p style="font-size: 16px; color: #64748b; margin-bottom: 16px; line-height: 1.5;">
          Transform any image into platform-ready posts in seconds
        </p>
      </div>
    `,
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="upload-section"]',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          📸 Step 1: Upload Image
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          Click here or drag and drop an image to get started. You can also switch to Brand Mode to create posts using your brand kit without an image.
        </p>
        <div style="background: #f1f5f9; padding: 12px; border-radius: 8px; border-left: 4px solid #6366f1;">
          <strong style="color: #6366f1;">💡 Pro Tip:</strong> 
          <span style="color: #475569; font-size: 13px;">Use high-quality images for best results</span>
        </div>
      </div>
    `,
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: 'body',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          📱 Step 2: Platform Selection
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          After uploading, AI automatically detects the best platforms for your content. Each platform gets optimized posts tailored to its audience and format.
        </p>
        <div style="background: #dcfce7; padding: 12px; border-radius: 8px; border-left: 4px solid #22c55e;">
          <strong style="color: #16a34a;">✨ Smart Feature:</strong> 
          <span style="color: #15803d; font-size: 13px;">Content is automatically adapted for each platform</span>
        </div>
      </div>
    `,
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: 'body',
    content: `
      <div style="padding: 16px;">
        <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #1e293b;">
          ⏰ Step 3: Schedule Options
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 12px; line-height: 1.5;">
          You can choose to schedule your posts immediately or save them as drafts for later. Perfect for planning your content calendar!
        </p>
        <div style="background: #fef3c7; padding: 12px; border-radius: 8px; border-left: 4px solid #f59e0b;">
          <strong style="color: #d97706;">⚡ Quick Tip:</strong> 
          <span style="color: #92400e; font-size: 13px;">Enable scheduling for instant publishing across all platforms</span>
        </div>
      </div>
    `,
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: 'body',
    content: `
      <div style="text-align: center; padding: 20px;">
        <div style="font-size: 22px; font-weight: bold; margin-bottom: 16px; color: #1e293b;">
          🎉 Ready to Create!
        </div>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 16px; line-height: 1.5;">
          Upload an image or use your brand kit to generate multiple platform-ready posts instantly!
        </p>
        <div style="background: linear-gradient(135deg, #f0f9ff, #e0f2fe); padding: 16px; border-radius: 12px; border: 1px solid #0ea5e9;">
          <div style="font-size: 16px; font-weight: bold; color: #0369a1; margin-bottom: 8px;">
            🚀 Quick Tips:
          </div>
          <div style="font-size: 13px; color: #0c4a6e; text-align: left;">
            • Use high-quality images for best results<br>
            • Select multiple platforms to maximize reach<br>
            • Enable scheduling for automated posting
          </div>
        </div>
      </div>
    `,
    placement: 'center',
    disableBeacon: true,
  },
];
